class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('sticky-header');
    this.activeElement = null;
  }

  getRenderedSectionHtml(html) {
    if (!html) return '';

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const renderedTarget = parsed.getElementById('cart-icon-bubble');
    if (renderedTarget) return renderedTarget.innerHTML;

    const section =
      parsed.getElementById('shopify-section-cart-icon-bubble') ||
      parsed.querySelector('.shopify-section');
    if (section) return section.innerHTML;

    return parsed.body.innerHTML;
  }

  renderContents(parsedState) {
    const html = parsedState?.sections?.['cart-icon-bubble'];
    const target = document.getElementById('cart-icon-bubble');
    const renderedHtml = this.getRenderedSectionHtml(html);

    if (target && renderedHtml.trim()) {
      target.innerHTML = renderedHtml;
    }

    if (this.header) this.header.reveal();

    document.dispatchEvent(
      new CustomEvent('buildingbasket:cart-updated', {
        detail: { source: 'cart-notification' },
      })
    );
  }

  getSectionsToRender() {
    return [{ id: 'cart-icon-bubble' }];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
